import { Component,ViewChild } from '@angular/core';
import { ViewWillEnter,IonContent  } from "@ionic/angular";
import { Router,ActivatedRoute } from "@angular/router";
import { WebOrderService } from '../../services/web-order.service';
import { WebProductAdmin } from '../../models/web-product.model';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ToasterService } from "../../../../common/services/toaster.service";
import { environment } from '../../../../../environments/environment.prod';
import { ModalController } from '@ionic/angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-web-customer-product-edit-page',
  templateUrl: 'web-customer-product-edit.page.html',
  styleUrls: [
    './web-customer-product-edit.page.scss',
  ]
})
export class WebCustomerProductEditPage  {
  customerCode:string="";
  customerDepts:any;
  selectedFunction:string;
  selectAll:boolean;
  loading:boolean=true ;
  productCode:string;
      constructor(
          private webOrderService: WebOrderService,
          private toasterService: ToasterService,
         private route: ActivatedRoute,
         private modalController:ModalController,
          private router: Router
        ) { 
    
      }
   ngOnInit() {
   this.selectedFunction="update";
     this.loadData();
    }
    async loadData() {
      this.loading=false;
      this.productCode = this.route.snapshot.paramMap.get('pid');
      this.customerCode = this.route.snapshot.paramMap.get('cid');
      this.customerDepts=await this.webOrderService.getWebCustomerProduct(this.customerCode,this.productCode);      
      this.loading=true;
      }
      toggleAllDepartments() {
          for (let dept of this.customerDepts) {
            dept.isSelected = this.selectAll;
          }
        }
    async UpdateCustomerProduct():Promise<void>{
      this.loading=false;
      if(this.customerDepts!=null && this.customerDepts!=undefined){
      if(this.selectedFunction=="update"){
     const selectedCustDepts = this.customerDepts
      .filter(pm => pm.isSelected);
      
      var response=await this.webOrderService.updateWebCustomerProduct(selectedCustDepts,this.customerCode, this.productCode);  
       if (response =='success') {
          this.toasterService.presentToast(
            "primary",
            "The Web Customer Product were updated.",
            "Success"
          );
         this.loading=true;
        } else {
          this.toasterService.presentToast(
            "danger",
            `Error Updating Web Customer Product.`,
            "Error"
          );
             this.loading=true;
        }
        }else{
   const modal = this.modalController.create({
                     component: ConfirmationPopupComponent,
                     cssClass: "min-width-modal",
                     componentProps: {
                      productCode: this.productCode,
                      tableName:"web_cust_prod",
                  },
                     showBackdrop: true,
                     backdropDismiss: true,
                     keyboardClose: true,
                     swipeToClose: true,
                   
                   });
              (await modal).present();
                 const {data} = await (await modal).onDidDismiss();
     if(data){
       var result=await this.webOrderService.deleteWebCustomerProduct(this.customerCode,this.productCode); 
       if (result =='success') {
          this.toasterService.presentToast(
            "primary",
            " The Item was Deleted from the Web Customer Products Table! ",
            "Success"
          );
             this.loading=true;
             
             this.router.navigate(['/admin-page/web-customer-product']);
        } else {
          this.toasterService.presentToast(
            "danger",
            `Error Deleting Web Customer Product.`,
            "Error"
          );  
             this.loading=true;
                }
         }
  
        }
    }
    else{
       this.toasterService.presentToast(
            "danger",
            `Web Customer Product Code not Found.`,
            "Error"
          );  
             this.loading=true;
    }
       this.loading=true;
  }

  } 